<div class="tab-container mt-4">
  <h3 class="app">Company Logo</h3>
  <div class="form-field-container pt-2">
    <div class="form-field grid gap-2">
      <p class="mt-1"><strong>Logo - Full</strong></p>
      <p class="mt-1">The full company logo is used in the main navigation and in email communications.</p>
      <div class="logo-full-container mt-3">
        <img [src]="siteConfigStore.siteConfig()?.logoUrl" alt="Company Logo" class="logo-full" />
        <p class="mt-1 bottom-4">{{ getFileName(siteConfigStore.siteConfig()?.logoUrl) }}</p>
      </div>
    </div>
    <div class="form-field grid gap-2">
      <p class="mt-1"><strong>Logo - Icon</strong></p>
      <p class="mt-1">The company icon is used in the collapsed navigation bar.</p>
      <div class="logo-full-container">
        <img [src]="siteConfigStore.siteConfig()?.iconUrl" alt="Company Icon" class="logo-full" />
        <p class="mt-1 bold">{{ getFileName(siteConfigStore.siteConfig()?.iconUrl) }}</p>
      </div>
    </div>
  </div>
  <h3 class="app mt-5">Style</h3>
  <div class="form-field-container pt-2">
    <div class="form-field grid gap-2">
      <p class="mt-1">The primary color is used for buttons and other text and highlights in the app.</p>
      <div class="logo-full-container">
        <p class="mt-1">
          <strong>Primary Color: {{ siteConfigStore.siteConfig()?.colorPrimary }}</strong>
        </p>
        <div class="color-swatch" [style.background]="siteConfigStore.siteConfig()?.colorPrimary"></div>
      </div>
    </div>
  </div>
  <h3 class="app mt-5">Portal Domain</h3>
  <div class="form-field-container pt-2">
    <div class="form-field grid gap-2">
      <p class="mt-1">The portal domain is the URL where you and your Agencies will access the app.</p>
      <p class="mt-1">
        <strong>{{ siteUrl }}</strong>
      </p>
      <div class="mt-5">
        <lib-button
          [cssType]="'btn-primary'"
          [icon]="'rightarrow'"
          [text]="'Copy Link to Clipboard'"
          [size]="'large'"
          (click)="copyToClipboard()"
        ></lib-button>
      </div>
    </div>
  </div>
  <p class="mt-1">To customize your branding, connect with your Program Administrator to modify these settings.</p>
</div>
